import { apiClient } from '../../common/ApiClient';
import { expand } from 'uri-template-lite';
import { OutputDataUrl } from './OutputDataUrl';
import { createApiQueryHook } from '../../common/queryClient/createApiQueryHook';
import { OutputDataConfirmationsType } from '../schema/types';
import { OutputDataConfirmationsSchema } from '../schema/OutputDataSchema';
import { OutputDescriptionProcessingStatesParams } from './useOutputDescriptionProcessingStatesQuery';

const getOutputDataConfirmations = (
  params?: OutputDescriptionProcessingStatesParams,
) =>
  apiClient
    .get<OutputDataConfirmationsType>(
      expand(OutputDataUrl.OUTPUT_DATA_CONFIRMATIONS_QUERY, params),
    )
    .then((response) => OutputDataConfirmationsSchema.parse(response.data));

export const useOutputDataConfirmationsQuery = createApiQueryHook(
  ['outputDataConfirmations'],
  getOutputDataConfirmations,
);
